import React, { useEffect, useState } from "react";
import "./styles.ts";
import { Input } from "../../../../../components/Input";
import { Button } from "../../../../../components/Button";
import { ReactComponent as Voltar } from "../../../../../assets/newImages/icons/angle-down.svg";
import Titulo from "../../../../../components/Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo.tsx";
import { Toggle } from "../../../../../components/Toggle/Toggle.tsx";
import { Select } from "../../../../../components/Select";
import { listasDePrecoApi } from "../../../../../hooks/listasDePreco.ts";
import { useTheme } from "../../../../../contexts/Theme/ThemeContext.tsx";
import { formatCurrencyInput } from "../../../../../services/Masks.tsx";
import {
  CriarCategoriaContainer,
  ContainerEditarListas,
  Botoes,
} from "./styles.ts";
import {
  noSpecialCharacters,
  percentageMask,
} from "../../../../../services/Masks.tsx";
import { unmaskPercentage } from "../../../../../services/Unmasks.tsx";
import { copy } from "../../../../../services/Functions.tsx";
import Swal from "sweetalert2";
import Form from "../../../../../components/Form";
import { boolean } from "../../../../../services/Functions.tsx";
import Table from "../../../../../components/Table/Table.tsx";

interface ListaDePrecoBoxProps {
  setListaDePrecoBox: (newValue: boolean) => void;
  setNovaListaDePreco: (newValue: { id: any; descricao: string; moeda: string; ativo: number }) => void;
  permitir_edicao: boolean;
  categorias: any[];
  permissoesPlano: any;
}

export const ListaDePrecoBox: React.FC<ListaDePrecoBoxProps> = ({
  setListaDePrecoBox,
  setNovaListaDePreco,
  permitir_edicao,
  categorias: categoriasParam,
  permissoesPlano,
}) => {
  const { theme } = useTheme();
  const [categorias, setCategorias] = useState<any[]>([]);
  const [formValid, setFormValid] = useState<boolean>(false);
  const [descricao, setDescricao] = React.useState<string>("");
  const [moeda, setMoeda] = React.useState<string>("");
  const [usarTabelaBase, setUsarTabelaBase] = React.useState<boolean>(false);
  const [aumentarDiminuir, setAumentarDiminuir] =
    React.useState<string>("aumentar");
  const [id_categoria, setIdCategoria] = React.useState<string>("");
  const [indice, setIndice] = React.useState<string>("0");
  const [listasDePreco, setListasDePreco] = React.useState<any[]>([]);
  const [listasDePrecoSelect, setListasDePrecoSelect] = React.useState<any[]>(
    []
  );
  const [salvando, setSalvando] = useState(false);
  const [reajustandoPrecos, setReajustandoPrecos] = React.useState<any>(false);
  const [id_lista_editando, setIdListaEditando] = React.useState<any>("0");
  const [tabelaSelecionada, setTabelaSelecionada] = React.useState<any>("0");
  const [editandoListasDePreco, setEditandoListasDePreco] =
    React.useState<any>(true);
  const [recarregarListasDePreco, setRecarregarListasDePreco] =
    React.useState<any>(false);
  const [filtroAtivo, setFiltroAtivo] = React.useState<'todos' | 'ativos' | 'inativos'>('todos');


  const isListaAtiva = (ativo: any): boolean => {
    if (ativo === false || ativo === 0 || ativo === "0" || ativo == null) {
      return false;
    }
    if (ativo === true || ativo === 1 || ativo === "1") {
      return true;
    }
    return boolean(ativo) === true;
  };

  const handleEditarListasDePreco = async () => {
    let listasEditar = copy(listasDePreco);

    listasEditar.forEach((lista) => {
      if (lista.ativo) {
        lista.ativo = "1";
      } else {
        lista.ativo = "0";
      }
    });

    listasDePrecoApi()
      .editarListaDePreco(listasEditar)
      .then((response) => {
        setEditandoListasDePreco(true);
        setRecarregarListasDePreco(!recarregarListasDePreco);
        Swal.fire({
          title: "Sucesso!",
          text: "Tabelas de preço editadas com sucesso",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((error) => {
        Swal.fire({
          title: "Erro!",
          text: "Erro ao editar tabelas de preço",
          icon: "error",
          showConfirmButton: true,
          confirmButtonText: "Ok",
        });
      });
  };

  const handleCriar = async () => {
    if (!permissoesPlano["TABELAS_DE_PRECOS"].permitido) {
      Swal.fire({
        title: "Erro!",
        text: "Você não tem permissão para criar tabelas de preço",
        icon: "error",
        showConfirmButton: true,
        confirmButtonText: "Ok",
      });

      return;
    }

    let indice_formatado = 0;
    let porcentagem_formatada = Number(indice);

    if (usarTabelaBase) {
      indice_formatado =
        aumentarDiminuir == "aumentar"
          ? 1 + porcentagem_formatada / 100
          : 1 - porcentagem_formatada / 100;
      if (indice_formatado < 0) indice_formatado = 0;
      setIndice(indice_formatado.toString());
    } else {
      setTabelaSelecionada("0");
      setIndice("0");
    }

    try {
      const response = await listasDePrecoApi().criarListaDePreco(
        descricao,
        id_lista_editando,
        indice_formatado,
        moeda,
        tabelaSelecionada
      );

      setEditandoListasDePreco(true);
      setDescricao("");
      setMoeda("");
      setUsarTabelaBase(false);
      setAumentarDiminuir("aumentar");
      setIndice("0");
      setTabelaSelecionada("0");

      // Return the newly created price list
      const newPriceList = {
        id: response.id || response.data?.id,
        descricao: descricao,
        moeda: moeda,
        ativo: 1,
      };

      setRecarregarListasDePreco(!recarregarListasDePreco);
      setEditandoListasDePreco(true);
      setNovaListaDePreco(newPriceList);

      await Swal.fire({
        title: "Sucesso!",
        text: "Tabela de preço criada com sucesso",
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });

      // Pass the new price list back to the parent component
      return newPriceList;
    } catch (error) {
      console.log(error);
      let erro = (error as any).response?.data?.error;
      if (erro == "TABELA_JA_EXISTE") {
        Swal.fire({
          title: "Erro!",
          text: "Já existe uma tabela de preço com esse nome",
          icon: "error",
          showConfirmButton: true,
          confirmButtonText: "Ok",
        });
      }
      return null;
    }
  };

  const handleReajustarPrecos = async () => {
    let indice_formatado = 0;
    let porcentagem_formatada = Number(indice);

    indice_formatado =
      aumentarDiminuir == "aumentar"
        ? 1 + porcentagem_formatada / 100
        : 1 - porcentagem_formatada / 100;
    if (indice_formatado < 0) indice_formatado = 0;
    setIndice(indice_formatado.toString());

    listasDePrecoApi()
      .reajustarPrecos(
        id_categoria,
        indice_formatado,
        id_lista_editando,
        descricao,
        moeda,
        tabelaSelecionada
      )
      .then((response) => {
        setEditandoListasDePreco(true);
        setDescricao("");
        setMoeda("");
        setUsarTabelaBase(false);
        setAumentarDiminuir("aumentar");
        setIndice("0");
        setTabelaSelecionada("0");
        Swal.fire({
          title: "Sucesso!",
          text: "Tabela de preço editada com sucesso",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          setEditandoListasDePreco(true);
          setRecarregarListasDePreco(!recarregarListasDePreco);
        });
      })
      .catch((error) => {
        let erro = error.response.data.error;
        if (erro == "TABELA_JA_EXISTE") {
          Swal.fire({
            title: "Erro!",
            text: "Já existe uma tabela de preço com esse nome",
            icon: "error",
            showConfirmButton: true,
            confirmButtonText: "Ok",
          });
        }
      });
  };

  useEffect(() => {
    const init = async () => {
      const listasDePreco = await listasDePrecoApi().getListas();
      setListasDePreco(listasDePreco);

      setListasDePrecoSelect(
        listasDePreco.map((lista) => {
          return {
            name: lista.descricao,
            value: lista.id,
          };
        })
      );

      setTabelaSelecionada(listasDePreco[0].id);
    };

    init();
  }, [recarregarListasDePreco]);

  useEffect(() => {
    setUsarTabelaBase(false);
    if (editandoListasDePreco) {
      setIdListaEditando("0");
      setDescricao("");
    } else {
      setTabelaSelecionada("0");
    }
  }, [editandoListasDePreco]);

  useEffect(() => {
    if (usarTabelaBase) {
      setTabelaSelecionada(listasDePreco[0].id);
    } else {
      setTabelaSelecionada("0");
    }
  }, [usarTabelaBase]);

  useEffect(() => {
    setCategorias([
      { name: "Todas as categorias", value: "0" },
      ...categoriasParam,
    ]);
    setIdCategoria(categoriasParam.length > 0 ? categoriasParam[0].value : "0");
  }, []);

  return (
    <>
      {editandoListasDePreco ? (() => {
        const listasFiltradas = listasDePreco.filter(lista => {
          const ativa = isListaAtiva(lista.ativo);
          const incluir = filtroAtivo === 'todos' ? true : 
                         filtroAtivo === 'ativos' ? ativa : 
                         filtroAtivo === 'inativos' ? !ativa : true;
          return incluir;
        });
        const tableColumns = [
          { 
            key: "descricao", 
            label: "Nome",
            mask: (value: string) => (
              <span
                className="fonteTexto"
                onClick={() => {
                  if(!permitir_edicao) return;
                  const listaDePreco = listasDePreco.find(lista => lista.descricao === value);
                  if (listaDePreco) {
                    setIdListaEditando(listaDePreco.id);
                    setDescricao(listaDePreco.descricao);
                    setMoeda(listaDePreco.moeda);
                    setEditandoListasDePreco(false);
                  }
                }}
                style={{ cursor: permitir_edicao ? 'pointer' : 'default' }}
              >
                {value}
              </span>
            )
          },
          { 
            key: "moeda", 
            label: "Moeda",
            mask: (value: string) => (
              <span
                className="fonteTexto"
                onClick={() => {
                  if(!permitir_edicao) return;
                  const listaDePreco = listasDePreco.find(lista => lista.moeda === value);
                  if (listaDePreco) {
                    setIdListaEditando(listaDePreco.id);
                    setDescricao(listaDePreco.descricao);
                    setMoeda(listaDePreco.moeda);
                    setEditandoListasDePreco(false);
                  }
                }}
                style={{ cursor: permitir_edicao ? 'pointer' : 'default' }}
              >
                {value}
              </span>
            )
          },
          {
            key: "situacao", 
            label: "Situação",
            sortKey: "ativo"
          }
        ];

        // Preparar dados para a tabela
        const tableData = listasFiltradas.map((listaDePreco, index) => ({
          ...listaDePreco,
          ativo: isListaAtiva(listaDePreco.ativo) ? 1 : 0,
          situacao: (
            <div className="center" style={{ gap: '10px' }}>
              <Toggle
                value={listaDePreco.ativo}
                isValid={listasDePreco.some(
                  (lista) =>
                    lista.ativo === "1" ||
                    lista.ativo === 1 ||
                    boolean(lista.ativo) === true
                )}
                invalidText="Deve haver pelo menos </br> uma tabela de preço ativa."
                onChange={async (newValue) => {
                  if (!newValue) {
                    const response = await Swal.fire({
                      title: "Atenção!",
                      text: "Inativar essa tabela de preço irá desativar todos os catálogos associados a ela. Tem certeza de que deseja continuar?",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonText: "Sim, inativar",
                      cancelButtonText: "Cancelar",
                      customClass: {
                        confirmButton: "btn-confirm",
                        icon: "custom-swal-icon",
                      },
                    });
                    if (!response.isConfirmed) {
                      return;
                    }
                  }
                  const novasListas = listasDePreco.map((lista) => {
                    if (lista.id === listaDePreco.id) {
                      return { ...lista, ativo: newValue };
                    }
                    return lista;
                  });
                  setListasDePreco(novasListas);
                }}
              />
              <span
                onClick={() => {
                  if(!permitir_edicao) return;
                  setIdListaEditando(listaDePreco.id);
                  setDescricao(listaDePreco.descricao);
                  setMoeda(listaDePreco.moeda);
                  setEditandoListasDePreco(false);
                }}
                className="editar fonteTexto"
                style={{ cursor: permitir_edicao ? 'pointer' : 'default' }}
              >
                Editar
              </span>
            </div>
          )
        }));

        return (
          <ContainerEditarListas theme={theme}>
            <Form
              className="form"
              id="form-listas"
              setFormValid={setFormValid}
              onSubmit={handleEditarListasDePreco}
            >
              <Titulo
                titulo="Tabelas de preço"
                subtitulo="Configure as tabelas de preço da sua conta."
                flexDirection="column-reverse"
              />
              {listasDePreco.length > 0 && (
                <div className="filtros-lista" style={{ marginBottom: '20px' }}>
                  <Select
                    value={filtroAtivo}
                    onChange={(newValue) => setFiltroAtivo(newValue as 'todos' | 'ativos' | 'inativos')}
                    options={[
                      { name: "Todas", value: "todos" },
                      { name: "Ativas", value: "ativos" },
                      { name: "Inativas", value: "inativos" }
                    ]}
                    className="select-filtro-listas"
                  />
                </div>
              )}
              {listasFiltradas.length > 0 ? (
                <Table
                  key={`table-${filtroAtivo}-${listasFiltradas.length}`}
                  columns={tableColumns}
                  data={tableData}
                  sortable={true}
                  selectable={false}
                  button={false}
                  page={1}
                  itensPorPagina={-1}
                />
              ) : listasDePreco.length > 0 ? (
                <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }} className="fonteTexto">
                  {`Nenhuma tabela ${filtroAtivo === 'ativos' ? 'ativa' : filtroAtivo === 'inativos' ? 'inativa' : ''} encontrada`}
                </div>
              ) : null}
            <div className="linha-pai">
              <div className="linha"></div>
            </div>
            {permitir_edicao && (
              <div className="nova-tabela fonteTexto">
                <span
                  onClick={() => {
                    setEditandoListasDePreco(false);
                    setMoeda("");
                  }}
                >
                  Adicionar nova tabela
                </span>
              </div>
            )}
            <Botoes theme={theme}>
              <div
                className="cancelar fonteTexto"
                onClick={() => {
                  setListaDePrecoBox(false);
                }}
              >
                <Voltar /> Voltar
              </div>
              <Button
                title="Salvar"
                type="submit"
                width="50%"
                className={`fonteTexto botao_alterar ${!formValid && "disabled"}`}
              />
            </Botoes>
          </Form>
        </ContainerEditarListas>
        );
      })() : (
        <CriarCategoriaContainer theme={theme}>
          <Titulo
            titulo={`${
              id_lista_editando == "0"
                ? "Nova tabela de preço"
                : `Editando tabela ${descricao}`
            }`}
            subtitulo={
              id_lista_editando == "0"
                ? "Configure as informações para criar uma nova tabela de preço."
                : ""
            }
            flexDirection="column-reverse"
          />

          <div className="inputs_nome_moeda">
            <Input
              label="Nome"
              type="text"
              name="nome"
              maxLength={24}
              mask={{ mask: noSpecialCharacters }}
              value={descricao}
              onChange={(newValue) => {
                setDescricao(newValue);
              }}
              placeholder="Nome da tabela de preço"
            />
            <Input
              label="Moeda"
              type="text"
              name="moeda"
              maxLength={9}
              mask={{ mask: formatCurrencyInput }}
              value={moeda}
              onChange={(newValue) => {
                setMoeda(newValue);
              }}
              placeholder="R$"
            />
          </div>

          {editandoListasDePreco && id_lista_editando != "0" ? (
            <div className="toggle">
              <Toggle
                value={reajustandoPrecos}
                onChange={(newValue) => {
                  if (categorias.length == 1) {
                    return Swal.fire({
                      title: "Erro!",
                      text: "Não há categorias cadastradas",
                      icon: "error",
                      showConfirmButton: true,
                      confirmButtonText: "Ok",
                    });
                  }
                  setReajustandoPrecos(newValue);
                }}
              />
              <div className="info">Reajustar preços</div>
            </div>
          ) : (
            <div className="toggle">
              <Toggle
                value={usarTabelaBase}
                onChange={(newValue) => {
                  setUsarTabelaBase(newValue);
                }}
              />
              <div className="info fonteRotulos">Usar outra tabela de preço como base.</div>
            </div>
          )}

          {reajustandoPrecos && (
            <>
              <div className="tabela">
                <Select
                  label="Categoria"
                  sizeLabel="medium"
                  value={id_categoria}
                  name="tabela"
                  required
                  options={categorias}
                  onChange={(newValue) => {
                    setIdCategoria(newValue);
                  }}
                />
              </div>
              <div className="ajustes">
                <Select
                  label="Ajuste de preço"
                  sizeLabel="medium"
                  value={aumentarDiminuir}
                  name="tabela"
                  options={[
                    {
                      name: "Aumentar",
                      value: "aumentar",
                    },
                    {
                      name: "Diminuir",
                      value: "diminuir",
                    },
                  ]}
                  onChange={(newValue) => {
                    setAumentarDiminuir(newValue);
                  }}
                />

                <Input
                  label="Porcentagem"
                  type="text"
                  name="nome"
                  mask={{
                    mask: percentageMask,
                    unmask: unmaskPercentage,
                  }}
                  value={indice}
                  onChange={(newValue) => {
                    let porcentagem = parseInt(newValue);

                    let valorPorcentagem = 0;
                    if (aumentarDiminuir == "aumentar") {
                      valorPorcentagem = porcentagem / 100;
                    } else {
                      valorPorcentagem = porcentagem / 100;
                    }
                    setIndice(valorPorcentagem.toFixed(2).replace(/^0/, ""));
                  }}
                  placeholder="0.0%"
                />
              </div>
            </>
          )}

          {usarTabelaBase && (
            <>
              <div className="tabela">
                <Select
                  label="Tabela de preço"
                  sizeLabel="medium"
                  value={tabelaSelecionada}
                  name="tabela"
                  options={listasDePrecoSelect}
                  onChange={(newValue) => {
                    setTabelaSelecionada(newValue);
                  }}
                />
              </div>
              <div className="ajustes">
                <Select
                  label="Ajuste de preço"
                  sizeLabel="medium"
                  value={aumentarDiminuir}
                  name="tabela"
                  options={[
                    {
                      name: "Aumentar",
                      value: "aumentar",
                    },
                    {
                      name: "Diminuir",
                      value: "diminuir",
                    },
                  ]}
                  onChange={(newValue) => {
                    setAumentarDiminuir(newValue);
                  }}
                />

                <Input
                  label="Porcentagem"
                  type="text"
                  name="nome"
                  mask={{
                    mask: percentageMask,
                    unmask: unmaskPercentage,
                  }}
                  value={indice}
                  onChange={(newValue) => {
                    let porcentagem = parseInt(newValue);

                    let valorPorcentagem = 0;
                    if (aumentarDiminuir == "aumentar") {
                      valorPorcentagem = porcentagem / 100;
                    } else {
                      valorPorcentagem = porcentagem / 100;
                    }
                    setIndice(valorPorcentagem.toFixed(2).replace(/^0/, ""));
                  }}
                  placeholder="0.0%"
                />
              </div>
            </>
          )}
          <Botoes theme={theme}>
            <div
              className="cancelar"
              onClick={() => {
                setEditandoListasDePreco(true);
              }}
            >
              <Voltar /> Voltar
            </div>
            <Button
              title="Salvar"
              className="botao_alterar"
              width="50%"
              loading={salvando}
              onClick={async () => {
                setSalvando(true);
                try {
                  if (id_lista_editando != "0" && reajustandoPrecos) {
                    await handleReajustarPrecos();
                  } else {
                    const newPriceList = await handleCriar();
                    // Pass the new price list back to the parent component
                    if (newPriceList) {
                      setNovaListaDePreco(newPriceList);
                      setEditandoListasDePreco(true);
                      setRecarregarListasDePreco(!recarregarListasDePreco);
                    }
                  }
                } finally {
                  setSalvando(false);
                }
              }}
              disabled={
                salvando ||
                descricao.length == 0 ||
                (reajustandoPrecos && !indice && usarTabelaBase && !indice) ||
                (reajustandoPrecos && !id_categoria)
              }
            />
          </Botoes>
        </CriarCategoriaContainer>
      )}
    </>
  );
};
